import { CallStatusDetailEnum, CallStatusEnum, ICall, ICallDisposition, IProperty } from 'features/calls/types'
import { orderBy } from 'lodash'
import { formatDecimals } from 'utils'
import { formatDateOnly, formatDateWithAMPM } from 'utils/date'

// constants
const SEPARATOR = '/'

export const formatValue = (callInfo: IProperty, separator?: string): string => {
  const { value, kind, format } = callInfo

  if (value === undefined) return ''

  const valueAsString = value.toString()

  switch (kind) {
    case 'date':
      return format === 'dateWithTime'
        ? formatDateWithAMPM(valueAsString, separator || SEPARATOR)
        : formatDateOnly(valueAsString)

    case 'number':
      return format === 'currency' ? formatDecimals(valueAsString) : valueAsString
    default:
      return valueAsString
  }
}

export const callDispositionValues: ICallDisposition[] = [
  { value: 1, description: 'CCSAP - Checked Claim Status via Automated Phone' },
  { value: 2, description: 'CLMPI - Left Message with Primary Insurer' },
]

export function getClaimCallJobStatus(calls: ICall[] | undefined): CallStatusEnum {
  if (!calls || calls.length <= 0) {
    return CallStatusEnum.Unknown
  }

  const mostRecentObject = orderBy(calls, 'jobRequested', 'desc')[0]
  const status = mostRecentObject?.status

  if (status === 1) {
    return CallStatusEnum.Queued
  }
  if (status === 2) {
    return CallStatusEnum.InProgress
  }
  if (status === 3) {
    return CallStatusEnum.Complete
  }
  if (status === 4) {
    return CallStatusEnum.FailedToComplete
  }
  if (status === 6) {
    return CallStatusEnum.RetryPending
  }
  return CallStatusEnum.Unknown
}

export function getCallSummaryMessage(call: ICall): string {
  const status = call.status

  if (status === 0) {
    return 'We were unable to start this call'
  }
  if (status === 5) {
    return 'This call was canceled'
  }
  if (status === 4) {
    const msg = getCallStatusDetailSummaryMessage(call)

    return msg
  }
  if (status === 6) {
    const msg = getCallStatusDetailSummaryMessage(call) + ' Retry is pending'
    return msg
  }
  return ''
}
export function getCallStatusDetailSummaryMessage(call: ICall): string {
  let msg = 'We were unable to complete this call'
  if (call.statusDetail === CallStatusDetailEnum.FailedNoAnswer) {
    msg = 'Payer did not pick up call.'
  }
  if (call.statusDetail === CallStatusDetailEnum.FailedBusy) {
    msg = 'Payer phone line busy.'
  }
  if (call.statusDetail === CallStatusDetailEnum.CallFailed) {
    msg = 'Failed to connect to payer.'
  }
  if (call.numberAttempts > 1) msg += ' Attempted ' + call.numberAttempts + ' times.'

  return msg
}
